import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import appError from '../../../appError';
import { BASE_URL } from '../../../appConstants';
import axios from 'axios';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { Button, CircularProgress } from '@mui/joy';
import ExportIcon from "../../../svg/Ads_Dashboard_Developement2/ExportIcon/elements.svg";
import { downloadCSV } from '../../../appFunctions';

type CampaignObj = {
    campaign_id: string;
    campaign_name: string;
    adgroup_id: string;
    adgroup_name: string;
    platform_code: string;
}
type CstObj = {
    bcg_type: string;
    cst: string;
    cst_id: string;
}
type PlatformObj = {
    platform_code: string;
}
type TargetingObj = {
    targeting_id: string;
    targeting: string;
}
const MappingPage:React.FC<{}> = ({}) => {
    const [tableDataTypeArr, setTableDataTypeArr] = useState<string[]>(["platform_code", "campaign", "targeting", "cst"]);
    const { brand_id } = useParams();
    const [platform_name, setPlatform_name] = useState<string>('');
    const [platform_id, setPlatform_id] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [exportloading, setExportLoading] = useState<boolean>(false);
    // Data
    const [campaignArr, setCampaignArr] = useState<CampaignObj[]>([]);
    const [cstArr, setCstArr] = useState<CstObj[]>([]);
    const [platform_codeArr, setPlatform_codeArr] = useState<PlatformObj[]>([]);
    const [targetingArr, setTargetingArr] =  useState<TargetingObj[]>([]);
    // Count
    const [counts, setCounts] = useState({
        campaign: 0,
        cst: 0,
        platform_code: 0,
        targeting: 0
      });

    const Platform_CodesColDefs: ColDef<PlatformObj>[] = [
        {
          field: "platform_code",
          headerName: "Platform Code",
          sortable: false,
        },
    ];

    const CampaignsColDefs: ColDef<CampaignObj>[] = [
        {
          field: "campaign_name",
          headerName: "Campaign Name",
          sortable: false,
        },
        {
            field: "campaign_id",
            headerName: "Campaign Id",
            sortable: false,
        },
        {
            field: "adgroup_name",
            headerName: "Ad Group Name",
            sortable: false,
        },
        {
            field: "adgroup_id",
            headerName: "Ad Group Id",
            sortable: false,
        },
        {
            field: "platform_code",
            headerName: "Platform Code",
            sortable: false,
        },
    ];

    const TargetingColDefs: ColDef<TargetingObj>[] = [
        {
          field: "targeting",
          headerName: "Targeting",
          sortable: false,
        },
    ];

    const CSTColDefs: ColDef<CstObj>[] = [
        {
          field: "cst",
          headerName: "CST",
          sortable: false,
        },
        {
            field: "bcg_type",
            headerName: "Recom BCG",
            sortable: false,
        },
    ];

    const defaultColDef = {
        flex: 1
    }

    const fetchTableData = async(p_platformName: string, p_platform_id: string, type: string, export_data_type: string, pagination_type: string) => {

        const token = localStorage.getItem("token");
        try {
            if(type === "FETCH_DATA"){
                setLoading(true);
            }else if(type === "EXPORT_DATA"){
                setExportLoading(true);
            }
            const headers = {
                Authorization: `Bearer ${token}`,
              };
              let api = `${BASE_URL}dashboards/adsDashboard/mapping?brand_id=${brand_id}&platform=${p_platformName}&platform_id=${p_platform_id}&tableDataArr=${tableDataTypeArr}&pagination=${pagination_type}`;
              const result = await axios.get(api, { headers });
              const {campaign, cst, platform_code, targeting} = result?.data?.data;

              if(type === 'FETCH_DATA'){
                    setCampaignArr(campaign?.data);
                    setCstArr(cst?.data);
                    setPlatform_codeArr(platform_code?.data);
                    setTargetingArr(targeting?.data);
                    setCounts(prev => ({ ...prev, 
                        campaign: campaign?.count,
                        cst: cst?.count,
                        platform_code: platform_code?.count,
                        targeting: targeting?.count
                    }));
                }else if(type === 'EXPORT_DATA'){
                    if(export_data_type === 'PLATFORM'){
                        const new_platform_code = platform_code?.data?.map((item: any) => {
                            return {
                              platform_code: item?.platform_code ?? "",
                            };
                          });
                        downloadCSV(new_platform_code, 'UnMappedPlatformCodes.csv');
                    } else if(export_data_type === 'CAMPAIGN'){
                        const new_campaign = campaign?.data?.map((item: any) => {
                            return {
                                campaign_name
                                : item?.campaign_name
                                ?? "",
                                campaign_id: item?.campaign_id ?? "",
                                adgroup_name: item?.adgroup_name ?? "",
                                adgroup_id: item?.adgroup_id ?? "",
                                platform_code: item?.platform_code ?? "",
                            };
                          });
                        downloadCSV(new_campaign, 'UnMappedCampaigns.csv');
                    } else if(export_data_type === 'TARGETING'){
                        const new_targetings = targeting?.data?.map((item: any) => {
                            return {
                              targeting: item?.targeting ?? "",
                            };
                          });
                        downloadCSV(new_targetings, 'UnMappedTargetings.csv');
                    } else if(export_data_type === 'CST'){
                        const new_csts = cst?.data?.map((item: any) => {
                            return {
                              cst: item?.cst ?? "",
                              Recom_Bcg : item?.bcg_type ?? ""
                            };
                          });
                        downloadCSV(new_csts, 'UnMappedCSTs.csv');
                    }
                }
        } catch (error) {
            appError(error);
        } finally {
            if(type === "FETCH_DATA"){
                setLoading(false);
            }else if(type === "EXPORT_DATA"){
                setExportLoading(false);
            }
        }
    }
    const getPlatformDetails = () => {
        const storedPlatform = localStorage.getItem("platform");
        if(storedPlatform){
            try {
                const parsedPlatform = JSON.parse(storedPlatform);
                setPlatform_name(parsedPlatform?.platform);
                setPlatform_id(parsedPlatform?.platform_id);
                if(parsedPlatform?.platform && brand_id && parsedPlatform?.platform_id){
                    fetchTableData(parsedPlatform?.platform, parsedPlatform?.platform_id, 'FETCH_DATA', '', 'LIMIT');
                }
            } catch (error) {
                appError("Error parsing Platform from localStorage:", error);
            }
        }
    }

    useEffect(() => {
       getPlatformDetails();
    }, [brand_id]);

  return (
    <>
        <div className="flex flex-col">
            <div
                className="flex py-3 px-[20px] items-center justify-between gap-1 self-stretch"
                style={{
                    borderBottom: "1px solid #EAEAED",
                }}
                >
                <div className="flex items-center gap-2">
                    <div
                    style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "20px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "26px",
                    }}
                    >
                    UnMapped Data
                    </div>
                </div>
            </div>

            <div className="px-[20px] py-3 flex justify-center items-center" style={{
                height: "calc(100vh - 123px)"
            }}>
                <div
                    className="flex w-full rounded-[8px] gap-2"
                    style={{
                    backgroundColor: "#FFF",
                    boxShadow: "0px 4px 16px 16px rgba(130,130,130,0.05)",
                    height: "calc(100vh - 146px)"
                }}>
                    {loading ? (
                <div
                  className="h-full w-full flex justify-center items-center"
                >
                  <CircularProgress />
                </div>
              ) : (
                    <div className="flex w-full rounded-[8px] gap-2">
                        {/* Platform Table */}
                        <div className="h-full rounded-[5px]" style={{
                            flex : 1.5,
                            // border: "1px solid #EAEAED",
                            
                        }}>
                            <div className="flex justify-between gap-2">
                            <div className="flex px-2 py-2 flex-col gap-2 self-stretch">
                                    <div
                                        className="self-stretch"
                                        style={{
                                            color: "var(--Text-Primary-Black, #1C1C1E)",
                                            fontFamily: "Inter",
                                            fontSize: "18px",
                                            fontStyle: "normal",
                                            fontWeight: 700,
                                            lineHeight: "20px",
                                        }}
                                        >
                                        New Platform Codes
                                    </div>

                                    <div
                                        className="self-stretch"
                                        style={{
                                            color: "var(--Text-Primary-Black, #1C1C1E)",
                                            fontFamily: "Inter",
                                            fontSize: "14px",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "16px",
                                        }}
                                        >
                                        Total Counts : {counts?.platform_code}
                                    </div>
                            </div>
                            <Button
                                sx={{
                                backgroundColor: "#FFF",
                                ":hover": {
                                    backgroundColor: "#FFF",
                                },
                                borderRadius: "6px",
                                paddingX: "6px",
                                paddingY: "0px",
                                border: `1px solid #EAEAED`,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "fit-content"
                                }}
                                onClick={() => fetchTableData(platform_name, platform_id, 'EXPORT_DATA', 'PLATFORM', 'ALL')}
                            >
                                <img
                                src={ExportIcon}
                                alt="Export Icon"
                                style={{ cursor: "pointer" }}
                                />
                            </Button>
                            </div>

                            <div className="w-full ag-theme-quartz" style={{
                                height: "calc(100vh - 146px - 60px)",
                            }}>
                                <AgGridReact
                                    rowData={platform_codeArr}
                                    columnDefs={Platform_CodesColDefs}
                                    defaultColDef={defaultColDef}
                                    rowHeight={32}
                                    headerHeight={36}
                                />
                            </div>
                        </div>

                        {/* Campaigns Table */}
                        <div className="h-full rounded-[5px]" style={{
                            flex : 4,
                            // border: "1px solid #EAEAED",
                            
                        }}>
                            <div className="flex justify-between gap-2">
                                <div className="flex px-2 py-2 flex-col gap-2 self-stretch">
                                        <div
                                            className="self-stretch"
                                            style={{
                                                color: "var(--Text-Primary-Black, #1C1C1E)",
                                                fontFamily: "Inter",
                                                fontSize: "18px",
                                                fontStyle: "normal",
                                                fontWeight: 700,
                                                lineHeight: "20px",
                                            }}
                                            >
                                            New Campaigns
                                        </div>

                                        <div
                                            className="self-stretch"
                                            style={{
                                                color: "var(--Text-Primary-Black, #1C1C1E)",
                                                fontFamily: "Inter",
                                                fontSize: "14px",
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "16px",
                                            }}
                                            >
                                            Total Counts : {counts?.campaign}
                                        </div>
                                </div>
                                <Button
                                    sx={{
                                    backgroundColor: "#FFF",
                                    ":hover": {
                                        backgroundColor: "#FFF",
                                    },
                                    borderRadius: "6px",
                                    paddingX: "6px",
                                    paddingY: "0px",
                                    border: `1px solid #EAEAED`,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "fit-content"
                                    }}
                                    onClick={() => fetchTableData(platform_name, platform_id, 'EXPORT_DATA', 'CAMPAIGN', 'ALL')}
                                >
                                    <img
                                    src={ExportIcon}
                                    alt="Export Icon"
                                    style={{ cursor: "pointer" }}
                                    />
                                </Button>
                            </div>
                            
                            <div className="w-full ag-theme-quartz" style={{
                                height: "calc(100vh - 146px - 60px)",
                            }}>
                                <AgGridReact
                                    rowData={campaignArr}
                                    columnDefs={CampaignsColDefs}
                                    defaultColDef={defaultColDef}
                                    rowHeight={32}
                                    headerHeight={36}
                                />
                            </div>
                        </div>

                        {/* Targetings Table */}
                        <div className="h-full rounded-[5px]" style={{
                            flex : 1.5,
                            // border: "1px solid #EAEAED",
                            
                        }}>
                            <div className="flex justify-between gap-2">
                                <div className="flex px-2 py-2 flex-col gap-2 self-stretch">
                                        <div
                                            className="self-stretch"
                                            style={{
                                                color: "var(--Text-Primary-Black, #1C1C1E)",
                                                fontFamily: "Inter",
                                                fontSize: "18px",
                                                fontStyle: "normal",
                                                fontWeight: 700,
                                                lineHeight: "20px",
                                            }}
                                            >
                                            New Targetings
                                        </div>

                                        <div
                                            className="self-stretch"
                                            style={{
                                                color: "var(--Text-Primary-Black, #1C1C1E)",
                                                fontFamily: "Inter",
                                                fontSize: "14px",
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "16px",
                                            }}
                                            >
                                            Total Counts : {counts?.targeting}
                                        </div>
                                </div>
                                <Button
                                    sx={{
                                    backgroundColor: "#FFF",
                                    ":hover": {
                                        backgroundColor: "#FFF",
                                    },
                                    borderRadius: "6px",
                                    paddingX: "6px",
                                    paddingY: "0px",
                                    border: `1px solid #EAEAED`,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "fit-content"
                                    }}
                                    onClick={() => fetchTableData(platform_name, platform_id, 'EXPORT_DATA', 'TARGETING', 'ALL')}
                                >
                                    <img
                                    src={ExportIcon}
                                    alt="Export Icon"
                                    style={{ cursor: "pointer" }}
                                    />
                                </Button>
                            </div>

                            <div className="w-full ag-theme-quartz" style={{
                                height: "calc(100vh - 146px - 60px)",
                            }}>
                                <AgGridReact
                                    rowData={targetingArr}
                                    columnDefs={TargetingColDefs}
                                    defaultColDef={defaultColDef}
                                    rowHeight={32}
                                    headerHeight={36}
                                />
                            </div>
                        </div>

                        {/* Csts Table */}
                        <div className="h-full rounded-[5px]" style={{
                            flex : 1.5,
                            // border: "1px solid #EAEAED",
                            
                        }}>
                            <div className="flex justify-between gap-2">
                                <div className="flex px-2 py-2 flex-col gap-2 self-stretch">
                                        <div
                                            className="self-stretch"
                                            style={{
                                                color: "var(--Text-Primary-Black, #1C1C1E)",
                                                fontFamily: "Inter",
                                                fontSize: "18px",
                                                fontStyle: "normal",
                                                fontWeight: 700,
                                                lineHeight: "20px",
                                            }}
                                            >
                                            New CSTs
                                        </div>

                                        <div
                                            className="self-stretch"
                                            style={{
                                                color: "var(--Text-Primary-Black, #1C1C1E)",
                                                fontFamily: "Inter",
                                                fontSize: "14px",
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "16px",
                                            }}
                                            >
                                            Total Counts : {counts?.cst}
                                        </div>
                                </div>
                                <Button
                                    sx={{
                                    backgroundColor: "#FFF",
                                    ":hover": {
                                        backgroundColor: "#FFF",
                                    },
                                    borderRadius: "6px",
                                    paddingX: "6px",
                                    paddingY: "0px",
                                    border: `1px solid #EAEAED`,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "fit-content"
                                    }}
                                    onClick={() => fetchTableData(platform_name, platform_id, 'EXPORT_DATA', 'CST', 'ALL')}
                                >
                                    <img
                                    src={ExportIcon}
                                    alt="Export Icon"
                                    style={{ cursor: "pointer" }}
                                    />
                                </Button>
                            </div>

                            <div className="w-full ag-theme-quartz" style={{
                                height: "calc(100vh - 146px - 60px)",
                            }}>
                                <AgGridReact
                                    rowData={cstArr}
                                    columnDefs={CSTColDefs}
                                    defaultColDef={defaultColDef}
                                    rowHeight={32}
                                    headerHeight={36}
                                />
                            </div>
                        </div>
                    </div>
              )}
                </div>
            </div>
        </div>
    </>
  )
}

export default MappingPage